/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import * as ReactDOMClient from 'react-dom/client';

import App from './App';



import './App.scss';

const ConfigWrapper = () => {
    
    useEffect(() => {
        if(process?.env?.ENVIRONMENT) {
            localStorage.setItem('environmentName', process?.env?.ENVIRONMENT)
            
            if(process?.env?.ENVIRONMENT === 'Development' && process.env.FEATURENAME) {
                console.log(process.env.FEATURENAME)
                localStorage.setItem('featureName', process.env.FEATURENAME)
            }
        }
    }, [])
    
    return (
        <App />
    )
}

const container = document.getElementById('root');

const root = ReactDOMClient.createRoot(container);

root.render(<ConfigWrapper />)